import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from '../pages/Home';
import AboutUs from '../pages/AboutUs'; 
import ContactUs from '../pages/ContactUs';
import ApplyNow from '../components/apply-now';
import ApplyNew from '../components/apply-now-new';
import ApplyNewForm from '../components/apply-new';
import TermsAndConditions from '../components/terms&conditions';
import PrivacyPolicy from '../components/privacy-policy'; 
import CorporateGovernancePage from '../pages/CorporateGovernancePage';
import FairPracticeCodePage from '../pages/FairPracticeCodePage';
import KycAndPmlaPage from '../pages/KycAndPmlaPage';
import RiskManagementPolicyComponent from '../components/risk-management-policy';
import TermsRatesComponent from '../components/terms-rates';
import Faqs from '../components/faqs'; 
import Career from '../pages/Career';
import InterestRatePolicy from '../components/interest-rate-policy';
import RepayLoan from '../pages/RepayLoan';
import RepayLoan1 from '../pages/RepayLoan1';
import KeyFactStatement from '../components/key-fact-statement';
import GetPanVerify from '../components/getpanverify';
import VideoKYC from '../components/video-kyc';
import Check from '../components/check';
import PaymentSuccess from '../components/PaymentSuccess';
import PartPayment from '../components/PartPayment';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about-us" element={<AboutUs />} />
      <Route path="/contact-us" element={<ContactUs />} />
      <Route path="/terms-conditions" element={<TermsAndConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/corporate-governance" element={<CorporateGovernancePage />} />
      <Route path="/fair-practice-code" element={<FairPracticeCodePage />} />
      <Route path="/interest-rate-policy" element={<InterestRatePolicy />} />
      <Route path="/kyc-and-pmla" element={<KycAndPmlaPage />} />
      <Route path="/risk-management-policy" element={<RiskManagementPolicyComponent />} />
      <Route path="/terms-rates" element={<TermsRatesComponent />} />
      <Route path="/faqs" element={<Faqs />} />
      <Route path="/career" element={<Career />} />
     <Route path="/repay-loan" element={<RepayLoan />} />
     <Route path="/repay-loan1" element={<RepayLoan1 />} />
      <Route path="/key-fact-statement" element={<KeyFactStatement />} />
      <Route path="/apply-now" element={<ApplyNow />} />
      <Route path="/apply-loan" element={<ApplyNow />} />
      <Route path='/apply-now-new' element={<ApplyNew />} />
      <Route path='/apply-new' element={<ApplyNewForm />} />
      <Route path='/apply-fundswall' element={<ApplyNewForm />} />
      <Route path='/getpanverify' element={<GetPanVerify />} />
      <Route path='/video-kyc' element={<VideoKYC />} />
      <Route path='/check' element={<Check />} />
      <Route path='/payment-success' element={<PaymentSuccess />} />
      <Route path='/part-payment' element={<PartPayment />} />

      <Route path="*" element={<div><h2>404 - Page Not Found</h2></div>} />
    </Routes>
  );
};

export default AppRoutes;
